<form [formGroup]="residenceForm">
  <div class="m-t-8 flex flex-col f-s-16">
    <span><strong>Residential history outside of Oregon in the past 5 years</strong></span>
    <span><strong>*</strong>This information is used for the purposes of the background check.</span>
    <span><strong>*</strong>City, state, country, from month/year to month/year.</span>
    <div class="m-t-8 flex flex-row" *ngFor="let residence of residentialHistory">
      <div class="flex flex-col">
        <div *ngIf="editingResidenceId !== residence.id" class="flex flex-col lg:flex-row gap-2 justify-start items-center w-full">
          <div class="flex flex-row gap-1">
            <span>{{residence.city}}</span>
            <span>{{residence.state}},</span>
            <span>{{residence.country}}</span>
            <span class="m-l-8"><strong>From:</strong></span>
            <span>{{residence.from | date: 'MMM, yyyy'}}</span>
            <span class="m-l-8"><strong>To:</strong></span>
            <span>{{residence.to | date: 'MMM, yyyy'}}</span>
          </div>
          <div *ngIf="!licenseLocked" class="flex flex-row">
            <button mat-icon-button class="m-8" (click)="editResidentialHistory(residence)" color="primary"
              aria-label="Add Residence">
              <mat-icon>create</mat-icon>
            </button>
            <button mat-icon-button class="m-8" (click)="deleteResidentialHistory(residence.id)" color="warn"
              aria-label="Delete Residence">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="editingResidenceId === residence.id" class="flex flex-col">
          <div class="text-red-400 flex md:flex-row flex-col" *ngIf="residenceHistoryIncomplete">
            Please provide all fields
          </div>
          <div class="flex flex-col gap-2 justify-start">
            <div class="flex md:flex-row flex-col gap-2">
              <mat-form-field>
                <input matInput placeholder="City" formControlName="city">
              </mat-form-field>

              <mat-form-field class="md:w-[25%]">
                <mat-label>State</mat-label>
                <mat-select formControlName="state">
                  <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="md:w-[25%]">
                <input matInput placeholder="Country" formControlName="country">
              </mat-form-field>
            </div>
          </div>
          <div class="flex md:flex-row flex-col gap-2 justify-start">
            <mat-form-field class="md:w-[40%]">
              <mat-label>From Month and Year</mat-label>
              <input matInput [matDatepicker]="from" formControlName="from">
              <mat-hint>MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
              <mat-datepicker #from
                              startView="multi-year"
                              (monthSelected)="setMonthAndYear($event, from, 'from')">
              </mat-datepicker>
            </mat-form-field>

            <mat-form-field class="md:w-[40%]">
              <mat-label>To Month and Year</mat-label>
              <input matInput [matDatepicker]="to" formControlName="to">
              <mat-hint>MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
              <mat-datepicker #to
                              startView="multi-year"
                              (monthSelected)="setMonthAndYear($event, to, 'to')">
              </mat-datepicker>
            </mat-form-field>
            <div *ngIf="!licenseLocked" class="flex flex-row">
              <button mat-icon-button class="m-8" (click)="updateResidentialHistory()" color="primary" aria-label="Add Residence">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button class="m-8" (click)="cancelResidentialHistoryEdit()" color="warn"
                aria-label="Cancel Edit">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="editingResidenceId === 0 && !licenseLocked" class="flex flex-col">
      <div class="text-red-400 flex flex-row" *ngIf="residenceHistoryIncomplete">
        Please provide all fields
      </div>
      <div class="flex flex-col gap-2 justify-start">
        <div class="flex md:flex-row flex-col gap-2">
          <mat-form-field>
            <input matInput placeholder="City" formControlName="city">
          </mat-form-field>

          <mat-form-field class="md:w-[25%]">
            <mat-label>State</mat-label>
            <mat-select formControlName="state">
              <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="md:w-[25%]">
            <input matInput placeholder="Country" formControlName="country">
          </mat-form-field>
        </div>
        <div class="flex md:flex-row flex-col gap-2 justify-start">
          <mat-form-field class="md:w-[40%]">
            <mat-label>From Month and Year</mat-label>
            <input matInput [matDatepicker]="from" formControlName="from">
            <mat-hint>MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
            <mat-datepicker #from
                            startView="multi-year"
                            (monthSelected)="setMonthAndYear($event, from, 'from')">
            </mat-datepicker>
          </mat-form-field>

          <mat-form-field class="md:w-[40%]">
            <mat-label>To Month and Year</mat-label>
            <input matInput [matDatepicker]="to" formControlName="to">
            <mat-hint>MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
            <mat-datepicker #to
                            startView="multi-year"
                            (monthSelected)="setMonthAndYear($event, to, 'to')">
            </mat-datepicker>
          </mat-form-field>

          <button mat-raised-button type="button" class="m-8" (click)="addResidentialHistory()" color="primary" aria-label="Add Residence">
            <mat-icon>add</mat-icon> Add
          </button>
        </div>


      </div>
    </div>

  </div>
</form>
